<template>
  <el-form
    :model="inviteUser"
    :rules="rules"
    ref="inviteUser"
    hide-required-asterisk
    label-position="top"
    class="brand-input brand-validation"
    @submit.prevent.native="sendInvite"
  >
    <div class="px-8 pt-6 pb-6">
      <p class="text-xl font-bold mb-6 text-brand-black">Invite via Email</p>
      <div class="grid grid-cols-2 gap-x-4">
        <el-form-item label="First name" prop="first" class="font-bold text-left">
          <el-input placeholder="Jane" ref="first" type="text" v-model="inviteUser.first"></el-input>
        </el-form-item>
        <el-form-item prop="last" label="Last name" class="font-bold text-left">
          <el-input placeholder="Doe" type="text" v-model="inviteUser.last"></el-input>
        </el-form-item>
      </div>
      <el-form-item prop="email" label="Email address" class="font-bold text-left">
        <el-input placeholder="jane@email.com" type="email" v-model="inviteUser.email"></el-input>
      </el-form-item>
      <div class="-mt-1">
        <p class="font-bold text-left mb-2">New User Role</p>
        <div>
          <el-form-item prop="role" style="margin-bottom: 0px">
            <el-select v-model="inviteUser.role" placeholder="Select Role" class="w-60">
              <el-option v-for="role in displayedRoles" :key="role.value" :label="role.label" :value="role.value" :disabled="role.disabled">
                <div class="flex items-center space-x-2">
                  <div class="w-20 font-semibold">{{ role.label }}</div>
                  <div class="text-xs text-gray-500 pr-2">{{ role.description }}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
    </div>
    <div class="bg-brand-light-sand border-t-2 border-brand-sand flex justify-end px-8 py-4 rounded-b-lg">
      <el-button @click="$emit('close')" type="plain" class="border-brand-gray-blue border-2 px-6 py-2 rounded-lg">
        <span class="text-sm text-brand-blue font-semibold">Nevermind</span>
      </el-button>
      <el-button v-loading="loading" native-type="submit" type="primary" class="font-bold py-2 px-6 rounded-lg text-sm">Send Invite</el-button>
    </div>
  </el-form>
</template>

<script>
import OrgService from '@/api/org.service';
import { availableRoles } from '@/store/modules/permissions';

const rules = {
  first: [{ required: true, message: 'First name is required', trigger: 'blur' }],
  last: [{ required: true, message: 'Last name is required', trigger: 'blur' }],
  email: [{ required: true, type: 'email', message: 'Email is required', trigger: 'blur' }],
};

export default {
  name: 'InviteForm',
  data() {
    return {
      loading: false,
      inviteUser: {
        email: '',
        first: '',
        last: '',
        role: 'ORG_MEMBER',
      },
      rules,
    };
  },
  computed: {
    displayedRoles() {
      const userRole = this.$store.state.user.role;
      const userRoleIndex = availableRoles.findIndex((d) => d.value === userRole);
      return availableRoles
        .filter((d) => d.value !== 'ORG_OWNER')
        .map((role) => {
          // check indexes of user role and role
          const targetRoleIndex = availableRoles.findIndex((d) => d.value === role.value);
          const disabled = targetRoleIndex < userRoleIndex;
          return {
            ...role,
            disabled,
          };
        });
    },
  },
  methods: {
    async sendInvite() {
      try {
        this.loading = true;
        const user = {
          name: `${this.inviteUser.first} ${this.inviteUser.last}`,
          email: this.inviteUser.email,
          role: this.inviteUser.role,
        };
        await OrgService.inviteUser(this.$store.state.user.org, user);
        this.$notify({ title: 'Member invitation sent', type: 'success' });
        this.$emit('sent');
        this.$emit('close');
        this.inviteUser = {
          email: '',
          first: '',
          last: '',
          role: 'ORG_MEMBER',
        };
      } catch (error) {
        this.$notify({ title: `User with that email already exists. Please contact support`, type: 'error' });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
